import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import Cam from '../../assets/icons/Cam';
import Magnifier from '../../assets/icons/Magnifier';
import RightArrow from '../../assets/icons/RightArrow';
import { Menu, Dropdown } from 'antd';
import { useDebounce } from 'use-debounce';

import logo from '../../assets/images/logo.png';

import avi from '../../assets/images/boy-skin6.png';
import LiveClassDropdown from '../Dropdown/LiveClassDropdown';

const DashboardHeader = ({ tutor }) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [debouncedText] = useDebounce(searchText, 1000);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem('userData'));

    if (!user) {
      navigate('/login');
    }
  }, []);

  //handle search
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  if (debouncedText) {
    if (window?.location?.href?.includes('result')) {
      console.log('result');
    } else {
      navigate(`/result/${selectedFilter.toLowerCase()}/${debouncedText}`);
    }
  }

  let userData = JSON.parse(localStorage.getItem('userData'));
  let schoolLogo = localStorage.getItem('schoolLogo');

  let notification = JSON.parse(localStorage.getItem('notification'));

  const menu = (
    <Menu placement='bottom'>
      <LiveClassDropdown />
    </Menu>
  );

  const filterMenuList = [
    { id: 1, item: 'All' },
    { id: 2, item: 'Topic' },
    { id: 3, item: 'School' },
    // { id: 4, item: 'Tutor' },
  ];

  const filterMenu = (
    <Menu placement='bottom'>
      <div className='filter-search'>
        {filterMenuList.map((el) => (
          <p
            className='filter-search__item'
            key={el.id}
            onClick={() => setSelectedFilter(el.item)}
          >
            {el.item}
          </p>
        ))}
      </div>
    </Menu>
  );

  return (
    <div className='dashboard-header'>
      <div className='dashboard-header__logo' onClick={() => navigate('/')}>
        <img src={logo} alt='' />
        <p>Beta</p>
      </div>
      {!tutor && (
        <div className='dashboard-header__search'>
          <Dropdown overlay={filterMenu} trigger={['click']}>
            <div
              className='dashboard-header__search__filter'
              style={{ cursor: 'pointer' }}
            >
              <Magnifier />
              <p className='dashboard-header__search__filter__text'>
                {selectedFilter}
              </p>

              <RightArrow />
            </div>
          </Dropdown>
          <input
            type='search'
            placeholder='Search for anything'
            value={searchText}
            onChange={(e) => onFilterChange(e)}
          />
        </div>
      )}
      <div className='dashboard-header__profile'>
        {!tutor && (
          <Dropdown overlay={menu} trigger={['click']}>
            <div style={{ cursor: 'pointer' }}>
              {notification && <div className='red-dot'></div>}
              <Cam />
            </div>
          </Dropdown>
        )}

        <div
          className='dashboard-header__profile__image'
          onClick={() => navigate('/profile')}
        >
          <img
            src={
              userData?.avatar || schoolLogo || userData?.school?.logo || avi
            }
            alt=''
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
